import * as React from 'react';
import { PrismicPreviewProvider } from 'components';

export const wrapRootElement = ({ element }) => <PrismicPreviewProvider element={element} />;
